import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import '../../assets/style/style.css';
import { useTranslation } from "react-i18next";
function OrderSummary(props) {
  const { t }     = useTranslation();
  const orderID            = props.orderID;
  const pageContent        = props.pageContent;


const getPaymentStatusBox = (status) => {
    let paymentStatusBox = '';

    switch (status) {
        case 'pending':
            paymentStatusBox = <Box className="paymentStatusBoxPending paymentStatusBoxDetails">{t(status)}</Box>;
            break;
        case 'refunded':
            paymentStatusBox = <Box className="paymentStatusBoxRefunded paymentStatusBoxDetails">{t(status)}</Box>;
            break;
        case 'voided':
            paymentStatusBox = <Box className="paymentStatusBoxVoided paymentStatusBoxDetails">{t(status)}</Box>;
            break;        
        default:
            paymentStatusBox = <Box className="paymentStatusBoxPaid paymentStatusBoxDetails">{t(status)}</Box>;
            break;
    }

    return paymentStatusBox;
};

const getOrderStatusBox = (status) => {
  let orderStatusBox = '';

  switch (status) {
      case 'open':
          orderStatusBox = <Box className="orderStatusBoxOpen orderStatusBoxDetails">{t(status)}</Box>;
          break;
      case 'accepted':
          orderStatusBox = <Box className="orderStatusBoxAccepted orderStatusBoxDetails">{t(status)}</Box>;
          break;
      case 'rejected':
          orderStatusBox = <Box className="orderStatusBoxRejected orderStatusBoxDetails">{t(status)}</Box>;
          break;      
      case 'partially fulfilled':
          orderStatusBox = <Box className="orderStatusBoxPartiallyFulfilled orderStatusBoxDetails">{t(status)}</Box>;
          break;      
      default:
          orderStatusBox = <Box className="orderStatusBoxFulfilled orderStatusBoxDetails">{t(status)}</Box>;
          break;
  }

  return orderStatusBox;
};

  return (
            <>
            <Grid item xs={12}>
                <Card mb={2} variant="outlined">
                  <CardContent>
                    <Grid item xs={12} my={2}>
                      <Typography variant="h6" color="text.secondary">
                        {t('Current order status')}
                      </Typography>
                      <Typography sx={{ fontSize: 14 }} component="div">
                        {t('Here are the current status of the order')}
                      </Typography>
                    </Grid>

                    <Grid container spacing={0} mt={1}>
                      <Grid item sm={9} xs={12}> 
                        <Grid container spacing={0} mt={1}>
                          <Grid item sm={6} xs={12} mb={2}>                       
                            <Typography sx={{ fontSize: 14 }} component="div">
                              <Box className="orderStatusBox">
                                <div className="orderStatusBoxLeft">{t('Ordered On')}</div>
                                <div className="orderStatusBoxMiddle">:</div>
                                <div className="orderStatusBoxRight">
                                  {pageContent.createdAt}
                                </div>
                              </Box>  
                            </Typography> 
                          </Grid>

                          <Grid item sm={6} xs={12} mb={2}>
                            <Typography sx={{ fontSize: 14 }} component="div">
                              <Box className="orderStatusBox">
                                <div className="orderStatusBoxLeft">{t('Order Status')}</div>
                                <div className="orderStatusBoxMiddle">:</div>
                                <div className="orderStatusBoxRight">
                                  {getOrderStatusBox(pageContent.orderStatus)}
                                </div>
                              </Box>  
                            </Typography> 
                          </Grid>

                          <Grid item sm={6} xs={12} mb={2}>                       
                            <Typography sx={{ fontSize: 14 }} component="div">
                              <Box className="orderStatusBox">
                                <div className="orderStatusBoxLeft">{t('Payment Method')}</div>
                                <div className="orderStatusBoxMiddle">:</div>
                                <div className="orderStatusBoxRight">                                  
                                  {pageContent.paymentGatewayNames}
                                </div>
                              </Box>  
                            </Typography> 
                          </Grid>

                          <Grid item sm={6} xs={12} mb={2}>
                            <Typography sx={{ fontSize: 14 }} component="div">
                              <Box className="orderStatusBox">
                                <div className="orderStatusBoxLeft">{t('Payment Status')}</div>
                                <div className="orderStatusBoxMiddle">:</div>
                                <div className="orderStatusBoxRight">
                                  {getPaymentStatusBox(pageContent.financialStatus)}
                                </div>
                              </Box>  
                            </Typography>  
                          </Grid>

                          {pageContent.shippingData ? 
                            <>
                              <Grid item sm={6} xs={12} mb={2}>
                                <Typography sx={{ fontSize: 14 }} component="div">
                                  <Box className="orderStatusBox">
                                    <div className="orderStatusBoxLeft">{t('Delivery Method')}</div>
                                    <div className="orderStatusBoxMiddle">:</div>
                                    <div className="orderStatusBoxRight">
                                      {t('Delhivery')}
                                    </div>
                                  </Box>  
                                </Typography>                         
                              </Grid>

                              <Grid item sm={6} xs={12} mb={2}>
                                <Typography sx={{ fontSize: 14 }} component="div">
                                  <Box className="orderStatusBox">
                                    <div className="orderStatusBoxLeft">{t('Shipping Applied By')}</div>
                                    <div className="orderStatusBoxMiddle">:</div>
                                    <div className="orderStatusBoxRight">
                                      {pageContent.shippingData.title}
                                    </div>
                                  </Box>  
                                </Typography>        
                              </Grid>
                            </>
                          : null}

                          {pageContent.customerEmail ? 
                            <Grid item xs={12} mb={2}>
                              <Typography sx={{ fontSize: 14 }} component="div">
                                <Box className="orderStatusBox">
                                  <div className="orderStatusBoxLeft">{t('Customer Email')}</div>
                                  <div className="orderStatusBoxMiddle">:</div>
                                  <div className="">
                                    {pageContent.customerEmail}
                                  </div>
                                </Box>  
                              </Typography>        
                            </Grid>
                          : null}

                          {pageContent.shippingAddress && pageContent.shippingAddress.phone ? 
                            <Grid item xs={12} mb={2}>
                              <Typography sx={{ fontSize: 14 }} component="div">
                                <Box className="orderStatusBox">
                                  <div className="orderStatusBoxLeft">{t('Customer Phone')}</div>
                                  <div className="orderStatusBoxMiddle">:</div>
                                  <div className="orderStatusBoxRight">
                                    {pageContent.shippingAddress.phone}
                                  </div>
                                </Box>  
                              </Typography>        
                            </Grid>
                          : null}

                          {pageContent.orderStatus === 'rejected' && pageContent.orderRejectNote ? 
                            <Grid item xs={12} mb={2}>
                              <Typography sx={{ fontSize: 14 }} component="div">
                                <Box className="orderStatusBox">
                                  <div className="orderStatusBoxLeft">{t('Rejection Note')}</div>
                                  <div className="orderStatusBoxMiddle">:</div>
                                  <div className="">
                                    {pageContent.orderRejectNote}
                                  </div>
                                </Box>  
                              </Typography>        
                            </Grid>
                          : null}


                        </Grid>                       

                      </Grid>
                      <Grid item sm={3} xs={12}> 
                        <Grid container spacing={0} mt={1}>    
                          <Grid item xs={12} mb={2}>
                            <Typography sx={{ fontSize: 14 }} component="div">
                              <Box className="orderStatusBox">
                                <div className="orderStatusBoxLeft">{t('Sub Total')}</div>
                                <div className="orderStatusBoxMiddle">:</div>
                                <div className="orderStatusBoxRight">
                                  {`₹${pageContent.totalPrice.toFixed(2)}`}
                                </div>
                              </Box>  
                            </Typography> 
                          </Grid>
                          <Grid item xs={12} mb={2}>
                            <Typography sx={{ fontSize: 14 }} component="div">
                              <Box className="orderStatusBox">
                                <div className="orderStatusBoxLeft">{t('Discount')}</div>
                                <div className="orderStatusBoxMiddle">:</div>
                                <div className="orderStatusBoxRight">
                                  {`₹${pageContent.totalDiscount.toFixed(2)}`}
                                </div>
                              </Box>  
                            </Typography>                         
                          </Grid>
                          <Grid item xs={12} mb={2}>
                            <Typography sx={{ fontSize: 14 }} component="div">
                              <Box className="orderStatusBox">
                                <div className="orderStatusBoxLeft">{t('Shipping')}</div>
                                <div className="orderStatusBoxMiddle">:</div>
                                <div className="orderStatusBoxRight">
                                  {`₹${parseFloat(pageContent.shippingPrice).toFixed(2)}`} 
                                </div>
                              </Box>  
                            </Typography>   
                          </Grid>
                          <Grid item xs={12} mb={2}>
                            <Typography sx={{ fontSize: 14 }} component="div">
                              <Box className="orderStatusBox">
                                <div className="orderStatusBoxLeft">{t('Total Tax (Inclusive)')}</div>
                                <div className="orderStatusBoxMiddle">:</div>
                                <div className="orderStatusBoxRight boxBottomBorder">
                                  {`₹${pageContent.totalTax.toFixed(2)}`}
                                </div>   
                              </Box>     
                            </Typography>                           
                          </Grid>
                          <Grid item xs={12} mb={2}>
                            <Typography sx={{ fontSize: 14 }} component="div">
                              <Box className="orderStatusBox">
                                <div className="orderStatusBoxLeft">{t('Net Payment')}</div>
                                <div className="orderStatusBoxMiddle">:</div>
                                <div className="orderStatusBoxRight">
                                  {`₹${( (parseFloat(pageContent.totalPrice) + parseFloat(pageContent.shippingPrice) ) - pageContent.totalDiscount).toFixed(2)}`}
                                </div>
                              </Box>  
                            </Typography>                         
                          </Grid>
                        </Grid>    
                      </Grid>
                    </Grid>                
                 
                  </CardContent>  
                </Card> 
              </Grid>       
          </>                       
        );
}
export default OrderSummary;
